// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application.widget .main.content {
  display: flex;
}

.application.widget .main.content > div {
  flex-direction: column;
}

.application.widget .ui.list {
  flex-grow: 100;
}

.application.widget .button.create-widget {
  max-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/widgets/Application/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".application.widget .main.content {\n  display: flex;\n}\n\n.application.widget .main.content > div {\n  flex-direction: column;\n}\n\n.application.widget .ui.list {\n  flex-grow: 100;\n}\n\n.application.widget .button.create-widget {\n  max-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
